import { mdiPencil } from '@mdi/js';
import i18n from 'es2015-i18n-tag';
import IconButton from '../../../common/ui-components/icon-button/icon-button.component';
import './team-edit-button.component.scss';
import { useNavigate } from 'react-router';

export interface TeamEditButtonProps {
    className?: string;
    id: string;
    isBusiness: boolean;
}

export const TeamEditButton = ({ className, id, isBusiness }: TeamEditButtonProps) => {
    const navigate = useNavigate();
    const urlPrefix = isBusiness ? '/teams/business' : '/teams/sport';

    return (
        <IconButton
            title={i18n`Team bearbeiten`}
            role="link"
            icon={mdiPencil}
            className={className}
            onClick={e => {
                e.preventDefault();
                navigate(`${urlPrefix}/${id}/edit`);
            }}
        />
    );
};

export default TeamEditButton;
